import React from 'react'
import { Paper } from '@material-ui/core'
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined'
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline'
import StarBorderIcon from '@material-ui/icons/StarBorder'
import EditIcon from '@material-ui/icons/Edit'
import dayjs from 'dayjs'

import IconButton from './IconButton'
import EditModal from './EditModal'

const isToday = require('dayjs/plugin/isToday')
dayjs.extend(isToday)

const EventCard = ({ bottomRight, campaignId, children, created, description, displayName, id, isEvent, isDarkMode, loading, setLoading, onDelete }) => {
  const [ isModalOpen, setIsModalOpen ] = React.useState(false)

  const handleEdit = () => {
    setIsModalOpen(true)
  }

  const handleDelete = () => {
    const shouldDelete = window.confirm('Are you sure you want to delete?')
    if (shouldDelete) onDelete(0)
  }

  const createdDate = dayjs(created?.toDate())
  let baseFormat = 'h:mm:ss a'
  if (!createdDate.isToday()) {
    baseFormat += ' [-] ddd[,] MMM D'
    if (createdDate.year() !== dayjs().year()) baseFormat += '[,] YYYY'
  }

  const borderColor = isDarkMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0,0,0,0.12)'

  return (
    <Paper variant='outlined' style={{ marginBottom: 16 }}>
      <EditModal
        campaignId={campaignId}
        description={description}
        id={id}
        isDarkMode={isDarkMode}
        isEvent={isEvent}
        isOpen={isModalOpen}
        loading={loading}
        setLoading={setLoading}
        setIsOpen={setIsModalOpen} />
      <div css={`
        display: flex;
        border-bottom: 1px solid ${borderColor};
        padding: 0 6px;
        justify-content: space-between;
        align-items: center;
        height: 37px;
      `}>
        <div css={`display: flex; align-items: center; font-weight: bold; line-height: 1; text-align: left;`}>
          {displayName === 'GM' &&
            <StarBorderIcon css={`margin-right: 4px;`} />
          }
          <span css={`line-height: 1; word-break: break-word;`}>{displayName}</span>
        </div>
        <div css={`height: 100%; display: flex; align-items: center;`}>
          <span css={`display: inline-block; opacity: 0.5; font-size: 12px; margin: 2px 5px 0 0; line-height: 1; text-align: right;`}>
            {createdDate.format(baseFormat)}
          </span>
          <IconButton title='Delete roll' onClick={handleDelete} disabled={loading}>
            <DeleteOutlineOutlinedIcon color='inherit' />
          </IconButton>
          <IconButton title='Edit roll' onClick={handleEdit} disabled={loading}>
            <EditIcon color='inherit' />
          </IconButton>
        </div>
      </div>
      {children}
      {(description || bottomRight) &&
        <div css={`color: grey; display: flex; border-top: 1px solid ${borderColor}; padding: 4px 6px; justify-content: space-between; align-items: center;`}>
          {description &&
            <div css={`display: flex; text-align: left; line-height: 1; align-items: center;`}>
              <ChatBubbleOutlineIcon fontSize='small' />
              <span css={`color: ${isDarkMode ? 'white' : 'black'}; opacity: 0.5; font-size: 12px; margin-left: 6px;`}>
                {description}
              </span>
            </div>
          }
          {bottomRight}
        </div>
      }
    </Paper>
  )
}

export default EventCard
